import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PseRoutingModule } from './pse-routing.module';
import { PseComponent } from './pse.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AlertModule } from '../../shared/components/alert/alert.module';
import { WhyRefundMoneyDialogComponent } from '../dialogs/why-refund-money-dialog/why-refund-money-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CdtCalculatorService } from 'src/app/shared/services/cdt-calculator.service';

@NgModule({
  declarations: [PseComponent, WhyRefundMoneyDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PseRoutingModule,
    MatSelectModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    DirectivesModule,
    PipesModule,
    AlertModule
  ],
  providers: [CdtCalculatorService]
})
export class PseModule {}
